

/* eslint-disable import/prefer-default-export */
export const ActiveDashboard = {

  activeDahsboardRequest: 'ACTIVE_DASHBOARD_PENDING',
  activeDahsboardSuccess: 'ACTIVE_DASHBOARD_SUCCESS',

  fetchDashboardDataRequest: 'FETCH_DASHBOARD_DATA_PENDING',
  fetchDashboardDataSuccess: 'FETCH_DASHBOARD_DATA_SUCCESS',

  removeChartFromDashboardRequest: 'REMOVE_CHART_FROM_DASHBOARD_PENDING',
  removeChartFromDashboardSuccess: 'REMOVE_CHART_FROM_DASHBOARD_SUCCESS',

  updateDashboardRequest: 'UPDATE_DASHBOARD_PENDING',
  updateDashboardSuccess: 'UPDATE_DASHBOARD_SUCCESS',

  refetchDashboardDataRequest: 'REFETCH_DASHBOARD_DATA_PENDING',
  refetchDashboardDataSuccess: 'REFETCH_DASHBOARD_DATA_SUCCESS',
};

